import * as React from "react";
import { useEffect, useState } from "react";
import logo from "../images/logo_dell.png"
import { useTranslation } from "react-i18next";
import i18next from "i18next";


interface obj {
    name: string,
    value: string
}
export default function Header() {
    const { t } = useTranslation("common");
    const dell_logo = t("dell");
    const lang_opts = [{ value: "en", name: "English (US)" },
    { value: "fr", name: "Français" },
    { value: "de", name: "Deutsch" },
    { value: "it", name: "Italiano" },
    { value: "es", name: "Español" },
    { value: "zhcn", name: "中文" },
    { value: "ja", name: "日本語" }];
    const [defVal, setDefVal] = useState(lang_opts[0].value);
    
    
    useEffect(()=>{
        if(localStorage && localStorage.getItem("lang_val")){
            setDefVal(localStorage.getItem("lang_val")||lang_opts[0].value);
        } else{
            setDefVal(lang_opts[0].value);
        }
        i18next.changeLanguage(defVal);
    },[defVal])
    
    const changeLang = (str:string) =>{
        localStorage.setItem("lang_val",str);
        setDefVal(str);
        i18next.changeLanguage(str);
    }
  

    return (
        <header className="dell-bg">
            <div className="container">
                <div className="d-flex align-items-center p-1">
        <div>
                        <a href="/" className="d-flex text-dark text-decoration-none align-items-center">
                        <img className="dell-logo" src={logo} alt={dell_logo} />
                            <span className="fs-6 text-blue px-md-3">{t("wyse_label")}</span>
                    </a>
                    </div>
                    <div className="dropdown ms-auto me-3">
                </div>
                 
                    <div>
                <select className="form-select" value={defVal} onChange={(e: any) => changeLang(e.target.value) }>
                    {lang_opts.map((lang: obj) => (<option value={lang.value} key={lang.value}>{lang.name}</option>))}
                </select>
            </div>
        </div>
            </div>
        </header>
    );
}